import { Field } from 'redux-form';
import React from 'react';
import './inputField.scss';
const SwitchInput = (props) => {
    const { fieldName, fieldIsDisbale, checkedValue, uncheckedValue, label,alignStartCss } = props;
    
    return <>
        <div className={`form-field-switch  ${alignStartCss ? "align-start" : ""}`}>
            {label || ""}
            <label className="switch">
                <Field
                    name={fieldName}
                    component={({ input, meta, ...rest }) => {
                        // Destructure custom values from props if passed
                        const {
                            checkedValue = true, // default to true
                            uncheckedValue = false, // default to false
                        } = rest;

                        const isChecked = input.value === checkedValue;

                        return (
                            <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={(e) =>
                                    input.onChange(e.target.checked ? checkedValue : uncheckedValue)
                                }
                                disabled={fieldIsDisbale}
                            />
                        );
                    }}
                    checkedValue={checkedValue}      // Optional custom value
                    uncheckedValue={uncheckedValue}  // Optional custom value
                />
                <span className="slider round" />
            </label>
        </div>
    </>
}
export default SwitchInput;